export const computationTableSx = {
  borderCollapse: "separate",
  "& .MuiTableCell-root": {
    px: 2,
    py: 1.25,
    borderColor: "divider",
    borderRight: "1px solid",
    borderRightColor: "divider",
    fontSize: "0.875rem",
  },
  "& .MuiTableCell-root:last-child": { borderRight: 0 },
  "& thead th": {
    bgcolor: "background.default",
    verticalAlign: "top",
    borderBottom: "2px solid",
    borderBottomColor: "divider",
  },
  "& tbody tr": { bgcolor: "background.paper" },
  "& tbody tr:nth-of-type(even)": {
    bgcolor: "background.default",
  },
  "& tr > :first-child": {
    position: "sticky",
    left: 0,
    zIndex: 1,
    bgcolor: "inherit",
    minWidth: { xs: 150, sm: 240 },
    maxWidth: { xs: 180, sm: 280 },
  },
  "& thead tr > :first-child": {
    zIndex: 3,
    bgcolor: "background.default",
  },
  "& tbody td": {
    whiteSpace: "nowrap",
  },
};
export const computationTableContainerSx = {
  maxHeight: "min(620px, 65vh)",
  border: "1px solid",
  borderColor: "divider",
  borderRadius: 1.5,
  "&:focus-visible": {
    outline: "2px solid",
    outlineColor: "primary.main",
    outlineOffset: 2,
  },
};
